var exports = {
  "lI": "DateOfBirthField.module__fieldset___WWF6Sl",
  "_A": "DateOfBirthField.module__labelContainer___WWF6Sl",
  "o1": "DateOfBirthField.module__legend___WWF6Sl",
  "$K": "DateOfBirthField.module__inputsContainer___WWF6Sl",
  "EN": "DateOfBirthField.module__fieldsRow___WWF6Sl",
  "tZ": "DateOfBirthField.module__monthField___WWF6Sl",
  "bc": "DateOfBirthField.module__dayField___WWF6Sl",
  "Y9": "DateOfBirthField.module__yearField___WWF6Sl",
  "kc": "DateOfBirthField.module__errorText___WWF6Sl",
  "Kd": "DateOfBirthField.module__nativeDateInput___WWF6Sl",
};

module.exports = exports;
